import React, { AriaRole } from "react";
import chevronRight from "../assets/images/chevron-right.svg";
import { isNullOrWhiteSpace } from "../shared/string";

interface Props {
  title: string;
  href: string;

  imgRole?: AriaRole;
  imgUrl?: string;
  imgAlt?: string;
  imgWidth?: number;
  imgHeight?: number;
}

export const CardLink = ({
  href,
  imgRole,
  imgAlt,
  imgHeight,
  imgUrl,
  imgWidth,
  title
}: Props) => (
  <a
    href={href}
    className="card focus:outline-none focus:shadow-card-outline group bg-neutral-100"
  >
    {!isNullOrWhiteSpace(imgUrl) && (
      <img
        src={imgUrl}
        alt={imgAlt}
        role={imgRole}
        width={imgWidth}
        height={imgHeight}
        className="mr-3"
        loading="lazy"
      />
    )}
    <span className="flex-1 text-base lg:text-lg font-bold uppercase">{title}</span>
    <svg
      width={12}
      height={12}
      className="card-arrow group-hover:translate-x-2 stroke-current"
    >
      <use xlinkHref={chevronRight.url} />
    </svg>
  </a>
);
